<div class="flex position--relative">
  <!-- EDGE -->
  <div
    class="border--default border--bottom position--relative"
    [@treeLinkInOut]="animate ? 'added' : null"
    [ngClass]="{
                   'border--left': isLastChild,
                   'br--bottom-left': isLastChild,
                   'h--5': isLastChild
                 }"
    [ngStyle]="{
                    height: isLastChild ? '28px' : '0',
                    top: isLastChild ? '-9px' : '17px',
                    width: isLastChild ? '17px' : '15px'
                 }"
  ></div>

  <!-- DELETE BUTTON -->
  <button
    taTooltipStatic="Delete"
    aria-label="Delete"
    (click)="delete.emit()"
    [ngStyle]="{
                transform: 'rotate(45deg)',
                opacity: hovered ? '100' : '0',
                transition: 'opacity 500ms',
                cursor: 'pointer',
                position: 'absolute',
                background: 'transparent',
                left: isLastChild ? '11px' : '10px',
                top: '-7px',
                zIndex: '3'
              }"
  >
    <ta-icon icon="plus"></ta-icon>
  </button>

  <!-- NODE -->
  <div
    [@treeNodeInOut]="animate ? 'added' : null"
    [@glowOnAppear]="animate ? 'added' : null"
    (@treeNodeInOut.done)="handleAnimationDone($event)"
    (mouseenter)="hovered = true"
    (mouseleave)="hovered = false"
  >
    <!-- STRING/NUMBER -->
    <div
      *ngIf="inputType === 'text' || inputType === 'number'"
      class="border--all br--default border--transparent position--relative"
      style="left: -2px"
    >
      <ta-input
        allowEmptyString
        expandToFitValue
        maxWidth="650px"
        [expansionTime]="expansionTime"
        class="monospace color--dark weight--bold glowOnAppear"
        [prefix]="key"
        [type]="inputType"
        [(value)]="value"
      ></ta-input>
    </div>

    <!-- BOOLEAN -->
    <div
      *ngIf="inputType === 'boolean'"
      class="
      flex
      align-items--center
      monospace weight--bold
      position--relative
      border--all
      br--default
      border--transparent
    "
      style="left: -2px"
      [@glowOnAppear]="animate ? 'added' : null"
    >
      <div
        *ngIf="key != null"
        class="
        border--left
        border--top
        border--bottom
        border--default
        br--bottom-left
        br--top-left
        p--2
        background--default
        color--dark
      "
      >
        {{ key }}
      </div>

      <div
        class="
        p--2
        border--all
        border--default
        br--top-right
        br--bottom-right
        pointer
      "
        [ngClass]="{
        'border--dark': hovered,
        'br--top-left': key == null,
        'br--bottom-left': key == null
      }"
        style="
        user-select: none;
        -ms-user-select: none;
      "
        (click)="toggleBoolean()"
      >
        {{ value }}
      </div>
    </div>


    <!-- UNDEFINED -->
    <div
      *ngIf="inputType == null"
      class="border--all br--default border--transparent position--relative"
      style="left: -2px"
    >
      <ta-input
        allowEmptyString
        expandToFitValue
        maxWidth="650px"
        [expansionTime]="expansionTime"
        class="monospace color--dark weight--bold glowOnAppear"
        [prefix]="key"
        type="text"
        disabled
        [value]="value || 'null'"
      ></ta-input>
    </div>
  </div>
</div>
